/* e-Ko Skin – timer cos + DISCOUNT SURPRIZĂ (Claude, 9 oct 2026)
 * La primul produs adaugat in cos porneste un timer de 60 de minute si se aplica automat
 * codul "DISCOUNT SURPRIZĂ" (-5% pe produse). Timerul apare DOAR daca reducerea chiar e aplicata:
 *  - mic, rosu, langa eticheta DISCOUNT SURPRIZĂ de la fiecare produs (.eko-line-timer)
 *  - discret, deasupra totalului in cosul lateral (.eko-cart-timer)
 * La expirare, codul e scos din cos (reducerea expira real). Un timer per cos (token), nu se reseteaza
 * daca clientul goleste si reumple cosul.
 * Daca codul dispare din cos (ex. dupa adaugarea cadoului), e reaplicat la urmatoarea schimbare a cosului.
 * Daca clientul are un cod propriu care nu se cumuleaza, codul lui ramane si timerul nu apare.
 */
(function () {
  'use strict';
  if (window.__ekoCartTimer) return;
  window.__ekoCartTimer = true;

  var CODE = 'DISCOUNT SURPRIZĂ';
  var DURATION = 60 * 60 * 1000;
  var KEY = 'ekoCartTimer2';
  var me = document.currentScript;
  var initialCount = me ? parseInt(me.getAttribute('data-count') || '0', 10) : 0;

  var origFetch = window.fetch.bind(window);
  var state = load();
  var expiresShown = null;
  var ticker = null;
  var syncing = false;
  var again = false;
  var debounceT = null;

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (e) { return null; }
  }
  function save() {
    try {
      if (state) localStorage.setItem(KEY, JSON.stringify(state));
      else localStorage.removeItem(KEY);
    } catch (e) { /* nimic */ }
  }
  function same(a, b) { return String(a || '').toUpperCase() === String(b || '').toUpperCase(); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function getCart() {
    return origFetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function setCodes(codes) {
    return origFetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }
  function applicableOthers(cart) {
    return (cart.discount_codes || []).filter(function (c) { return !same(c.code, CODE) && c.applicable; })
      .map(function (c) { return c.code; });
  }
  // "amprenta" cosului: daca se schimba (alte coduri / alt continut), merita incercat din nou
  function fingerprint(cart, others) {
    var ids = (cart.items || []).map(function (i) { return i.variant_id + 'x' + i.quantity; }).sort().join(',');
    return others.slice().sort().join('|').toUpperCase() + '#' + ids;
  }

  /* ---------- afisare ---------- */
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 1.5M9 2h6"/></svg>';

  function ensureEl() {
    var footer = document.querySelector('cart-drawer .cart-drawer__footer');
    if (!footer) return null;
    var el = footer.querySelector('.eko-cart-timer');
    if (!el) {
      el = document.createElement('div');
      el.className = 'eko-cart-timer';
      el.setAttribute('role', 'status');
      el.hidden = true;
      var anchor = footer.querySelector('[data-merge="footer"]');
      footer.insertBefore(el, anchor || footer.firstChild);
    }
    return el;
  }

  function fmt(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(s / 60);
    s = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function setLines(txt) {
    var nodes = document.querySelectorAll('.eko-line-timer');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== txt) nodes[i].textContent = txt;
    }
  }

  function paint() {
    var left = expiresShown ? expiresShown - Date.now() : 0;
    var el = ensureEl();
    if (expiresShown && left <= 0) {
      expiresShown = null;
      stopTicker();
      setLines('');
      if (el) el.hidden = true;
      sync(); // scoate codul
      return;
    }
    var txt = expiresShown ? fmt(left) : '';
    setLines(txt);
    if (!el) return;
    if (!expiresShown) { el.hidden = true; return; }
    var html = ICON + '<span>Reducere surpriză aplicată · expiră în <b>' + txt + '</b></span>';
    if (el.innerHTML !== html) el.innerHTML = html;
    el.hidden = false;
  }

  function stopTicker() { if (ticker) { clearInterval(ticker); ticker = null; } }
  function render(expires) {
    expiresShown = expires || null;
    stopTicker();
    if (expiresShown) ticker = setInterval(paint, 1000);
    paint();
  }

  function refreshDrawer() {
    if (document.body && document.body.classList.contains('template-cart')) {
      window.location.reload();
      return;
    }
    var form = document.querySelector('cart-drawer cart-form');
    if (form && typeof form.refresh === 'function') {
      try { form.refresh(); } catch (e) { /* nimic */ }
    }
  }

  /* ---------- logica ---------- */
  function decide(cart) {
    var codes = cart.discount_codes || [];
    var ours = codes.filter(function (c) { return same(c.code, CODE); })[0];
    var others = codes.filter(function (c) { return !same(c.code, CODE); }).map(function (c) { return c.code; });

    if (!cart.item_count) { render(null); return false; }

    if (!state || state.token !== cart.token) {
      state = { token: cart.token, expires: Date.now() + DURATION, blockedFor: null };
      save();
    }

    if (Date.now() >= state.expires) {
      render(null);
      if (ours) return setCodes(others).then(function () { return true; });
      return false;
    }

    if (!ours) {
      var fp = fingerprint(cart, others);
      if (state.blockedFor === fp) { render(null); return false; } // deja incercat in exact aceasta situatie
      var before = applicableOthers(cart);
      return setCodes(others.concat(CODE)).then(getCart).then(function (c2) {
        var o2 = (c2.discount_codes || []).filter(function (c) { return same(c.code, CODE); })[0];
        var after = applicableOthers(c2);
        var lostOwnCode = before.some(function (code) { return after.indexOf(code) === -1; });
        if (!o2 || !o2.applicable || lostOwnCode) {
          // nu se poate aplica acum (ex. codul clientului nu se cumuleaza) -> pastram codul clientului
          state.blockedFor = fp;
          save();
          return setCodes(others).then(function () { render(null); return true; });
        }
        state.blockedFor = null;
        save();
        render(state.expires);
        return true;
      });
    }

    render(ours.applicable ? state.expires : null);
    return false;
  }

  function sync() {
    if (syncing) { again = true; return; }
    syncing = true;
    getCart()
      .then(decide)
      .then(function (changed) { if (changed) refreshDrawer(); })
      .catch(function () { /* nimic */ })
      .then(function () {
        syncing = false;
        if (again) { again = false; sync(); }
      });
  }

  function later() {
    clearTimeout(debounceT);
    debounceT = setTimeout(sync, 600);
  }

  /* ---------- cand se schimba cosul ---------- */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var p = origFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && CART_RE.test(url)) p.then(later, function () {});
    } catch (e) { /* nimic */ }
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (/^post$/i.test(String(method)) && CART_RE.test(String(url))) this.addEventListener('loadend', later);
    } catch (e) { /* nimic */ }
    return xOpen.apply(this, arguments);
  };
  document.addEventListener('on:cart:after-merge', function () { paint(); later(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden && (state || initialCount)) { paint(); later(); } });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { paint(); later(); } });

  function boot() {
    if (initialCount > 0 || state) sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
